<div class="photoeditor-container">
  <!-- TOOLS -->
  <div class="photoeditor-tools">
    <ul>
      <!-- Clear selection -->
      <li (click)="deleteShape()" *ngIf="selectedNumberingElement || selectedShapeElement || selectedPath">
        <span class="material-icons-outlined ns-button--menu" style="color: red">delete</span>
      </li>

      <!-- Zoom In -->
      <li (click)="onListItemClick('zoomIn')" [ngClass]="{ 'is-active': selectedAction === 'zoom-in' }">
        <span class="material-icons-outlined ns-button--menu">zoom_in</span>
      </li>

      <!-- Zoom Out -->
      <li (click)="onListItemClick('zoomOut')" [ngClass]="{ 'is-active': selectedAction === 'zoom-out' }">
        <span class="material-icons-outlined ns-button--menu">zoom_out</span>
      </li>

      <!-- Numbering -->
      <li (click)="onListItemClick('numbering')" [ngClass]="{ 'is-active': selectedAction === 'numbering' }">
        <span class="material-icons-outlined ns-button--menu">insert_comment</span>
        <span class="photoeditor-tools__numbering">{{ numberingIndex }}</span>
      </li>

      <!-- Freehand -->
      <li (click)="onListItemClick('freeHand')" [ngClass]="{ 'is-active': selectedAction === 'freeHand' }">
        <span class="material-icons-outlined ns-button--menu">edit</span>
      </li>

      <!-- Shape -->
      <li
        (click)="onListItemClick('shape')"
        [ngClass]="{ 'is-active': ['shape', 'rectangle', 'circle'].indexOf(selectedAction) !== -1 }"
      >
        <span class="material-icons-outlined ns-button--menu">{{ activeShapeIcon }}</span>
        <div class="photoeditor-tools__submenu" *ngIf="isShapeSubmenuActive">
          <ul>
            <li (click)="rectangleShape()">
              <span class="material-icons-outlined ns-button--menu">crop_din</span>
            </li>
            <li (click)="circleShape()">
              <span class="material-icons-outlined ns-button--menu">circle</span>
            </li>
            <!-- <li (click)="clearShape()">
              <span class="material-icons-outlined ns-button--menu">clear</span>
            </li> -->
          </ul>
        </div>
      </li>

      <!-- Stroke -->
      <li (click)="onListItemClick('stroke')" [ngClass]="{ 'is-active': selectedAction === 'stroke' }">
        <span class="material-icons-outlined ns-button--menu">horizontal_split</span>
        <div class="photoeditor-tools__submenu" *ngIf="isStrokeSubmenuActive">
          <ul>
            <li (click)="selectStroke(stroke)" *ngFor="let stroke of availableStrokes; let i = index">
              <div
                class="ns-button--menu tool-line"
                [ngClass]="{ 'is-selected': strokeWidth === stroke }"
                [style.height]="2.5 * (i + 1) + 'px'"
              ></div>
            </li>
          </ul>
        </div>
      </li>

      <!-- Color -->
      <li (click)="onListItemClick('color')" [ngClass]="{ 'is-active': selectedAction === 'color' }">
        <span
          class="material-icons ns-button--menu"
          [style.color]="selectedColor.background"
          style="-webkit-text-stroke: 2px rgb(255, 255, 255)"
          >circle</span
        >
        <div class="photoeditor-tools__submenu" *ngIf="isColorSubmenuActive">
          <ul>
            <ng-container *ngFor="let color of availableColors">
              <li *ngIf="color.background !== selectedColor.background" (click)="selectColor(color)">
                <span
                  class="material-icons ns-button--menu"
                  [style.color]="color.background"
                  *ngIf="color.background !== selectedColor.background"
                  >circle</span
                >
              </li>
            </ng-container>
          </ul>
        </div>
      </li>

      <!-- Description -->
      <li
        *ngIf="selectedNumberingElement"
        (click)="description()"
        id="trigger"
        [ngClass]="{ 'is-active': selectedAction === 'description' || !isModalVisible }"
      >
        <span class="material-icons-outlined ns-button--menu">edit_note</span>
      </li>
    </ul>
  </div>

  <div class="empty"></div>

  <div class="photoeditor-edit-area" id="annotation-edit-component" #svgtarget></div>

  <div class="photoeditor-modal">
    <div class="photoeditor-modal__content">
      <div class="photoeditor-modal__header">
        <h3><span>Your comment</span></h3>
        <div class="close-button">
          <span class="material-icons-outlined">close</span>
        </div>
      </div>
      <div class="photoeditor-modal__body">
        <textarea #comment name="comment" rows="10" cols="50"></textarea>
      </div>
      <div>
        <div class="ir-row">
          <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6 close-modal-button">
            <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left"><span>Cancel</span></div>
          </div>
          <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6 save-modal-button">
            <button type="submit" class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right">
              <span>Save</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
